import { LESE_ANSICHTEN } from "./lese-ansichten";
import { LESE_FLAECHE_KLASSE, LESE_KNOTEN_KLASSEN } from "./lese-stile";

/**
 * Alle Optionen, die `useHornEditor` (`@horn/editor/kern`) für den Lesepfad braucht (Paket E-W1). So aufrufen:
 * `useHornEditor({ value: seiteAlsJson, onChange: () => {}, ...leseHuelleOptionen("Seiteninhalt") })`.
 * Der Editor ist damit schreibgeschützt und registriert das vollständige Wiki-Schema mit diesen Darstellungen; die
 * Altfassungen der Knoten werden nicht eingehängt. Reine Daten und Bausteine; das Paket hängt nicht von `@horn/editor` ab.
 */
export function leseHuelleOptionen(label: string) {
  return {
    editorKlasse: LESE_FLAECHE_KLASSE,
    editorAttribute: { "aria-label": label },
    knotenKlassen: LESE_KNOTEN_KLASSEN,
    wikiLinkSymbol: false,
    lesen: { ansichten: LESE_ANSICHTEN },
  } as const;
}
